import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=dfdffe6e&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfdffe6e')) {
      api.createRecord('dfdffe6e', component.options)
    } else {
      api.reload('dfdffe6e', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=dfdffe6e&", function () {
      api.rerender('dfdffe6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25hHyzRE479gO/JS/comp/IncreaseNumber.vue"
export default component.exports